'use client';

import { useEffect } from 'react';

import NextError from 'next/error';
import posthog from 'posthog-js';

import { IS_PRODUCTION } from '@/common/constants';
import { useDevErrorReset } from '@/hooks/use-dev-error-reset';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (IS_PRODUCTION) {
      posthog.captureException(error);
    }
  }, [error]);

  useDevErrorReset(error, reset);

  return (
    <html>
      <body>
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
